export default __webpack_public_path__ + "static/media/partner-light.1a6a8a0f.png";